import { useLeadOptions } from '../hooks'
import { IFilterCriteria } from '../interfaces'
import { ICONS_MAP, LABEL_MAP } from '../constants'

export const FilterDefinition = ({
   filterCriteria,
}: {
   filterCriteria: IFilterCriteria
}) => {
   const { options: ponds } = useLeadOptions('assigned_pond_id')

   const getDisplayValue = (value: string) => {
      if (filterCriteria?.field === 'assigned_pond_id') {
         const pond = ponds.find((p) => p.value === value)
         return pond?.label || value
      }
      return value
   }

   return (
      <div className="flex items-start gap-2">
         <div className="w-[100px] h-[34px] shrink-0 inline-flex items-center gap-2 rounded-lg bg-[#9F7BFF]/10 border border-[#9F7BFF]/20 px-3">
            <span className="text-[#A684FF]">
               {filterCriteria?.field &&
                  ICONS_MAP[filterCriteria.field as keyof typeof ICONS_MAP]}
            </span>
            <span className="text-white font-medium text-sm">
               {filterCriteria?.field &&
                  LABEL_MAP[filterCriteria.field as keyof typeof LABEL_MAP]}
            </span>
         </div>
         {filterCriteria?.value.length > 0 && (
            <div className="flex flex-wrap items-center gap-2 flex-1 min-w-0">
               {filterCriteria.value.map((value, index) => (
                  <span
                     key={index}
                     className="rounded-md text-white text-xs border border-white/[0.1] bg-white/[0.05] px-3 h-[34px] inline-flex items-center font-medium"
                  >
                     {getDisplayValue(value.toString())}
                  </span>
               ))}
            </div>
         )}
      </div>
   )
}
